import {
  type FontSize,
  type LineHeight,
  type ThemeTextColor,
  fontSizeMap,
  lineHeightMap,
  themeTextColorMap,
} from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'

type CurrencyContainerProps = Readonly<{
  className?: string
  text: string
  textColor?: ThemeTextColor
  fontSize?: FontSize
  lineHeight?: LineHeight
}>

export const CurrencyLabel = ({
  className = '',
  text,
  textColor,
  fontSize,
  lineHeight,
}: CurrencyContainerProps) => {
  return (
    <span
      className={cn(
        'flex flex-col self-end uppercase font-semibold whitespace-nowrap',
        fontSize ? fontSizeMap[fontSize] : 'text-sm',
        lineHeight ? lineHeightMap[lineHeight] : 'leading-loose',
        textColor ? themeTextColorMap[textColor] : themeTextColorMap.tertiary,
        className
      )}
    >
      {text}
    </span>
  )
}
